import 'css-chunksrc/client/common/filterMenu/resources/styles.scss';export default {
  "resources": "_resources_wgzic_1",
  "row": "_row_wgzic_5",
  "header": "_header_wgzic_15",
  "avatar": "_avatar_wgzic_24",
  "iconBox": "_iconBox_wgzic_31",
  "icon": "_icon_wgzic_31",
  "title": "_title_wgzic_47",
  "name": "_name_wgzic_54",
  "list": "_list_wgzic_61",
  "scrollPane": "_scrollPane_wgzic_65"
};